// ═══════════════════════════════════════════════════════════════════════
// data/auth.js — Supabase auth session/user reads (extracted from App.js)
// ═══════════════════════════════════════════════════════════════════════
// Centralises the repeated "grab the current session/user" pattern that was
// inlined ~20× across components (mostly to read session.access_token for
// authenticated backend calls). Behaviour-identical: returns the same session
// / user object the inline destructuring produced (no error handling change —
// callers never inspected the error). Uses getSession() (not refreshSession)
// deliberately — see loadWorkspacesFromDB notes in db.js.
import { supabase } from "../lib/supabaseClient";

export async function getCurrentSession() {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
}

export async function getCurrentUser() {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}
